import { AuctionType } from '@prisma/client';
import Link from 'next/link';
import React from 'react'

interface Props {
  auctionType: AuctionType;
}

const BidInstructions = ({ auctionType }: Props) => {
  return (
    <div className="w-full bg-slate-50 rounded-lg border-l-4 border-magenta/75 pl-4 py-4 mt-4 text-muted-foreground text-[15px] flex flex-col gap-1 lg:pr-4">
      {auctionType === AuctionType.HYBRID ? (
        <div>
          <span className="font-normal ml-1 text-foreground/80">Only <Link href="/bidding-info" className="text-blue-700 font-medium">standard bids</Link> are allowed in hybrid auctions.</span>
        </div>
      ) : (
        <>
          <div>
            <span className="font-medium text-foreground/80">Place bid:</span>
            <span className="font-normal ml-1">places a bid at the entered amount.</span>
          </div>
          <div>
            <span className="font-medium text-foreground/80">Set max bid:</span>
            <span className="font-normal ml-1">automatically bids for you up to a maximum amount.</span>
          </div>
        </>
      )}
    </div>
  )
}

export default BidInstructions